// @flow

import get from 'lodash/get';
import { store as CONFIG_STORE } from 'Config';

/**
 * selectMarketingCampaignId
 *
 * @param {Object} state
 * @returns number | null
 */
export function selectMarketingCampaignId(state: Object): number | null {
  return get(state[CONFIG_STORE.keys.marketing], 'data.id', null);
}
